import { findAllUpgradePageVariables } from '__generatedTypes__/findAllUpgradePage'
import { OrderDirection } from '__generatedTypes__/globalTypes'

export const getUpgradePageQueryVariables = (
  platformId: string,
  isForNewUsers: boolean
): findAllUpgradePageVariables => ({
  query: {
    order: {
      salesPrice: OrderDirection.ASC,
    },
    where: {
      isForNewUsers,
      platform: {
        id: platformId,
      },
    },
  },
})
